module.exports = __webpack_public_path__ + "static/media/us.7978889a.svg";